var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"a7-aplicacao"},[_c('gw-nav-bar',{attrs:{"categories":_vm.menu}},[_c('template',{slot:"end"},[_c('a7-sessao-usuario')],1)],2),_c('div',{staticClass:"a7-aplicacao-router-view"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }